import { useEffect, useRef } from 'react';
import { testimonials } from '@/mocks/home';

export default function TestimonialsSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.reveal-on-scroll');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-20 md:py-28 overflow-hidden">
      {/* Background image */}
      <img
        src="https://media.base44.com/images/public/6a33f776ca9ab1423a01beaf/4e4f16654_image.png"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-primary-500/50" />

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
        <h2 className="reveal-on-scroll font-heading text-3xl sm:text-4xl font-bold text-center mb-12 text-white">
          What Members Say
        </h2>

        <div className="grid sm:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`reveal-on-scroll animation-delay-${(index + 1) * 100} bg-background-50 border border-background-200/70 rounded-2xl p-6`}
            >
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm" />
                ))}
              </div>
              <p className="text-sm text-foreground-600 mb-4 leading-relaxed font-body">
                &ldquo;{testimonial.quote}&rdquo;
              </p>
              <p className="font-label font-medium text-sm text-foreground-950">
                {testimonial.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}